module.exports = __webpack_public_path__ + "img/icon2.f272ee8f.png";